import { render, staticRenderFns } from "./ParcelleEditor.vue?vue&type=template&id=1f3c9db1&scoped=true&lang=pug&"
import script from "./ParcelleEditor.vue?vue&type=script&lang=js&"
export * from "./ParcelleEditor.vue?vue&type=script&lang=js&"
import style0 from "./ParcelleEditor.vue?vue&type=style&index=0&id=1f3c9db1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3c9db1",
  null
  
)

export default component.exports